import { render, staticRenderFns } from "./LearningHub.vue?vue&type=template&id=27780e52&scoped=true"
import script from "./LearningHub.vue?vue&type=script&lang=js"
export * from "./LearningHub.vue?vue&type=script&lang=js"
import style0 from "./LearningHub.vue?vue&type=style&index=0&id=27780e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27780e52",
  null
  
)

export default component.exports